import axios from '@/utils/request'

export default {
  dashboardLineChart: data => axios({ url: '/api/report/lineChart', method: 'POST', data }),// 仪表板-折线图
  dashboardFunnel: data => axios({ url: '/api/report/funnel', method: 'POST', data }),// 转化漏斗
  dashboardProductSort: data => axios({ url: '/api/report/productSort', method: 'POST', data }),// 产品销量，产品浏览量，加入购物车数量排名
  dashboardVistiorDetails: data => axios({ url: '/api/report/vistiorDetails', method: 'POST', data }),// 访客详情
  // dashboardProductReport: data => axios({ url: '/api/report/productReport', method: 'POST', data }),// 产品统计
  dashboardGetCartQtySort: data => axios({ url: '/api/report/getCartQtySort', method: 'POST', data }),// 产品添加购物车排名
  dashboardGetVisitorQtySort: data => axios({ url: '/api/report/getVisitorQtySort', method: 'POST', data }),// 产品访客排名
  dashboardGetSalesVolumeQtySort: data => axios({ url: '/api/report/getSalesVolumeQtySort', method: 'POST', data }),// 产品销量排名
  dashboardImportExportFile: data => axios({ url: '/api/admin/importExportFile', method: 'POST', data }),// 新增导入导出任务
  // 事件分析
  eventStudyGetData: data => axios({ url: '/api/report/eventAnalysisStatistics', method: 'POST', data }),// 获取事件统计分析
  eventStudyGetEventList: () => axios({ url: '/api/report/eventAnalysisSelect', method: 'GET' }),// 获取事件统计查询条件
  eventStudyEventEdit: data => axios({ url: '/api/report/eventAnalysisLabe', method: 'put', data }),// 编辑登录用户绑定事件分类
  userBehaviorEdit: data => axios({ url: '/api/store/userBehavior', method: 'put', data }),// 编辑用户行为信息
  userBehaviorGet: params => axios({ url: '/api/store/userBehavior', method: 'get', params }),// 获取用户行为信息
  
  // 仪表盘
  getDashboard: params => axios({ url: '/api/report/combinedStatistics', method: 'get', params }), // 获取首页仪表盘
  dashboardSalesSort: data => axios({ url: '/api/report/salesSort', method: 'POST', data }), // 按国家分类访客，按来源分类访客
  dashboardPage: data => axios({ url: '/api/report/webPage', method: 'POST', data }), // 网页统计报表
  getDashboardDialog: data => axios({ url: '/api/report/details', method: 'post', data }), // 获取仪表盘banner、分类、活动、猜你喜欢弹窗列表
  
}